import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import ContactPage from "./pages/ContactPage";
import GroupBookings from "./pages/GroupBookings";
import GroupBookingsForm from "./pages/GroupBookingsForm";
import Press from "./pages/Press";
import TakeOut from "./pages/TakeOut";
import HolidayCelebration from "./pages/HolidayCelebration";
import DineOut from "./pages/DineOut";
import ValentinesDay from "./pages/ValentinesDay";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="groupbookings" element={<GroupBookings />} />
      <Route path="groupbookings_form" element={<GroupBookingsForm />} />
      <Route path="take-out" element={<TakeOut />} />
      {/* <Route path="dine-out" element={<DineOut />} /> */}
      {/* <Route path="valentines-day" element={<ValentinesDay />} /> */}
      {/* <Route path="press" element={<Press />} /> */}
    </Routes>
  </BrowserRouter>,
);

reportWebVitals();
